import React from "react";
import { gql } from "@apollo/client";

import { Chip, Grid } from "@mui/material";
import { Eye as ShowIcon } from "mdi-material-ui";

import useLocalStorage from "lib/localStorage";

export function useHiddenStates() {
  const [hiddenStates, setHiddenStates] = useLocalStorage(
    "lapidou::orders::hiddenStates::v2",
    () => []
  );

  const hideState = React.useCallback(
    ({ id, label }) => setHiddenStates([...hiddenStates, { id, label }]),
    [hiddenStates, setHiddenStates]
  );

  const unhideState = React.useCallback(
    ({ id }) =>
      setHiddenStates(hiddenStates.filter((state) => state.id !== id)),
    [hiddenStates, setHiddenStates]
  );

  return { hiddenStates, hideState, unhideState };
}

export default function HiddenStates() {
  const { hiddenStates, unhideState } = useHiddenStates();

  return (
    <Grid container spacing={0.5}>
      {hiddenStates.map((state) => (
        <Grid item key={state.id}>
          <Chip
            label={state.label}
            size="small"
            clickable
            onClick={() => unhideState(state)}
            onDelete={() => unhideState(state)}
            deleteIcon={<ShowIcon />}
          />
        </Grid>
      ))}
    </Grid>
  );
}

HiddenStates.fragments = {
  orderState: gql`
    fragment HiddenStates_orderState on OrderState {
      id
      label
    }
  `,
};
